import { Store } from 'components/common/types/Store.types';
import { useSelector } from 'react-redux';
import { getOffsetDifference } from 'utils/getOffsetDifference';
import { getTimezone } from 'store/publisher/selectors';

export const useMarketDateOffset = (): number => {
  const startDateOffset = useSelector((state: Store) => state.publisher.startDateOffset);
  const timezone = useSelector(getTimezone);

  return startDateOffset + getOffsetDifference(timezone);
};
